import '../i18n';
import '../stylesheets/auth_wizard.css';

import axios from 'axios';
import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import { getAccountDataByPasswordResetToken } from '../actions/account';
import {
  resetPassword,
  updateAndResendActivationEmail,
} from '../actions/register';
import eyeClosedIcon from '../assets/auth/eye-closed.svg';
import eyeOpenIcon from '../assets/auth/eye-open.svg';
import logoSvg from '../assets/logo.svg';
import FormInput from '../components/FormInput';
import StatusAlerts from '../components/StatusAlerts';
import { COMMUNICATION_LANGUAGES } from '../constants/constants';
// import i18n from '../i18n';
import { validateResetPasswordForm } from '../utils/validators';

const i18nPrefix = 'ResetPasasword';
const AUTH_UI_LANGUAGE_KEY = 'auth_ui_language';

function readPersistedValue(key) {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

function writePersistedValue(key, value) {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    // ignore write failures
  }
}

class ResendEmail extends React.Component {
  constructor(props) {
    super(props);
    const defaultLanguage = this.getDefaultLanguage();
    this.state = {
      loading: false,
      success: false,
      error: false,
      account_token: '',
      email: '',
      mobile: '',
      uiLanguage: defaultLanguage,
      passwordVisible: false,
      repeatPasswordVisible: false,
    };
  }

  componentDidMount() {
    // Check if we are registered with a account_token
    if (this.props.match.params.token) {
      const token = this.props.match.params.token;

      getAccountDataByPasswordResetToken(
        token,
        (account) => {
          this.setState({ email: account.email, token: token });
        },
        (error) => {
          this.setState({
            error: true,
            errorMessage: this.props.t('errors.somethingWentWrong'),
          });
        },
      );
    }
  }

  getDefaultLanguage() {
    const persisted = readPersistedValue(AUTH_UI_LANGUAGE_KEY);
    if (persisted && COMMUNICATION_LANGUAGES.includes(persisted)) {
      return persisted;
    }
    const i18nLanguage = this.props?.i18n?.language;
    if (i18nLanguage) {
      const normalized = i18nLanguage.split('-')[0].toUpperCase();
      if (COMMUNICATION_LANGUAGES.includes(normalized)) {
        return normalized;
      }
    }
    const sourceLanguage =
      typeof navigator !== 'undefined' && navigator.language
        ? navigator.language
        : 'en';
    const browserLanguage = sourceLanguage.split('-')[0].toUpperCase();
    if (COMMUNICATION_LANGUAGES.includes(browserLanguage)) {
      return browserLanguage;
    }
    return 'EN';
  }

  handleUiLanguageChange = (event) => {
    const nextLanguage = event.target.value;
    const { i18n } = this.props;
    if (!COMMUNICATION_LANGUAGES.includes(nextLanguage)) {
      return;
    }
    this.setState({ uiLanguage: nextLanguage });
    if (i18n?.changeLanguage) {
      i18n.changeLanguage(nextLanguage.toLowerCase());
    }
    writePersistedValue(AUTH_UI_LANGUAGE_KEY, nextLanguage);
  };

  handleResendClick = () => {
    const data = {
      token: this.state.token,
      password: this.state.password,
    };
    const formErrors = validateResetPasswordForm(this.state);
    this.setState({ loading: true, success: false, error: false }, () => {
      resetPassword(
        data,
        (response) => {
          this.setState({
            loading: false,
            success: true,
            error: false,
            successMessage: this.props.t(`${i18nPrefix}.paswordHasBeenReset`, {
              email: this.state.email,
            }),
          });
          setTimeout(() => {
            window.location.href = 'https://boatpark.app';
          }, 3000);
        },
        (err) => {
          this.setState({
            loading: false,
            uccess: false,
            error: true,
            errorMessage: this.props.t('errors.somethingWentWrong'),
          });
        },
      );
    });
  };

  render() {
    const { t } = this.props;
    const { uiLanguage } = this.state;
    const formErrors = validateResetPasswordForm(this.state);

    return (
      <Container
        style={{
          maxWidth: 800,
          marginTop: 50,
          borderRadius: 5,
          backgroundColor: 'white',
        }}>
        <div className='auth-header' style={{ marginBottom: '2rem' }}>
          <div className='auth-header__top'>
            <img src={logoSvg} alt='BoatPark' className='auth-logo' />
            <div className='auth-language-select-wrapper'>
              <span className='auth-language-select__icon' aria-hidden='true'>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  aria-hidden='true'
                  focusable='false'>
                  <circle
                    cx='12'
                    cy='12'
                    r='9'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    fill='none'
                  />
                  <ellipse
                    cx='12'
                    cy='12'
                    rx='4.5'
                    ry='9'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    fill='none'
                  />
                  <path
                    d='M3 12h18M4.5 7.5h15M4.5 16.5h15'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                  />
                </svg>
              </span>
              <select
                className='auth-language-select'
                value={uiLanguage}
                onChange={this.handleUiLanguageChange}>
                {COMMUNICATION_LANGUAGES.map((language) => (
                  <option key={language} value={language}>
                    {language}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <h1>{t(`${i18nPrefix}.title`)}</h1>
        </div>
        <FormInput
          type='email'
          label={t(`${i18nPrefix}.email`)}
          value={this.state.email}
          error={formErrors.email}
          disabled
        />
        <div className='auth-password-field'>
          <FormInput
            type={this.state.passwordVisible ? 'text' : 'password'}
            label={t(`${i18nPrefix}.password`)}
            value={this.state.password}
            error={formErrors.password}
            onChange={(event) =>
              this.setState({ password: event.target.value })
            }
          />
          <button
            type='button'
            className='auth-password-toggle'
            onClick={() =>
              this.setState((prevState) => ({
                passwordVisible: !prevState.passwordVisible,
              }))
            }>
            <img
              src={this.state.passwordVisible ? eyeClosedIcon : eyeOpenIcon}
              alt={t('auth.togglePassword')}
            />
          </button>
        </div>
        <div className='auth-password-field'>
          <FormInput
            type={this.state.repeatPasswordVisible ? 'text' : 'password'}
            label={t(`${i18nPrefix}.passwordRepeat`)}
            value={this.state.repeatPassword}
            error={formErrors.repeatPassword}
            onChange={(event) =>
              this.setState({ repeatPassword: event.target.value })
            }
          />
          <button
            type='button'
            className='auth-password-toggle'
            onClick={() =>
              this.setState((prevState) => ({
                repeatPasswordVisible: !prevState.repeatPasswordVisible,
              }))
            }>
            <img
              src={
                this.state.repeatPasswordVisible ? eyeClosedIcon : eyeOpenIcon
              }
              alt={t('auth.togglePassword')}
            />
          </button>
        </div>
        {!this.state.success && (
          <Button
            disabled={this.state.loading}
            variant='primary'
            type='submit'
            onClick={() => this.handleResendClick()}>
            {t(`${i18nPrefix}.reset`)}
          </Button>
        )}

        <StatusAlerts
          state={this.state}
          successMessage={this.state.successMessage}
          errorMessage={this.state.errorMessage}
        />
      </Container>
    );
  }
}

export default withTranslation()(ResendEmail);
